import React from 'react';
import {MAX_CONVICTIONS} from '../../data/creation';
import {vtmT} from '../../i18n';
import {TextField} from './CreationParts';

export const ConceptStep = ({name, setName, sheet, change}) => (
  <div className="vtmStepFields">
    <TextField id="vtmName" label={vtmT('name')} value={name} onChange={setName} />
    <TextField id="vtmConcept" label={vtmT('concept')} value={sheet.concept} placeholder={vtmT('conceptPlaceholder')} onChange={concept => change({...sheet, concept})} />
    <TextField id="vtmAmbition" label={vtmT('ambition')} value={sheet.ambition} placeholder={vtmT('ambitionPlaceholder')} onChange={ambition => change({...sheet, ambition})} />
    <TextField id="vtmDesire" label={vtmT('desire')} value={sheet.desire} placeholder={vtmT('desirePlaceholder')} onChange={desire => change({...sheet, desire})} />
    <TextField id="vtmSire" label={vtmT('sire')} value={sheet.sire} onChange={sire => change({...sheet, sire})} />
  </div>
);

export const ConvictionsStep = ({sheet, change}) => {
  const convictions = sheet.convictions.length > 0 ? sheet.convictions : [{conviction: '', touchstone: ''}];
  const setConviction = (index, patch) => change({
    ...sheet,
    convictions: convictions.map((item, i) => (i === index ? {...item, ...patch} : item)),
  });
  return (
    <div className="vtmStepFields">
      {convictions.map((item, index) => (
        <fieldset key={index} className="vtmConvictionEditor">
          <legend>{vtmT('conviction')} {index + 1}</legend>
          <TextField
            id={`vtmConviction${index}`}
            label={vtmT('conviction')}
            value={item.conviction}
            placeholder={vtmT('convictionPlaceholder')}
            onChange={conviction => setConviction(index, {conviction})}
          />
          <TextField
            id={`vtmTouchstone${index}`}
            label={vtmT('touchstone')}
            value={item.touchstone}
            placeholder={vtmT('touchstonePlaceholder')}
            onChange={touchstone => setConviction(index, {touchstone})}
          />
          {convictions.length > 1 && (
            <button type="button" className="vtmButton ghost small" onClick={() => change({...sheet, convictions: convictions.filter((_, i) => i !== index)})}>
              {vtmT('remove')}
            </button>
          )}
        </fieldset>
      ))}
      {convictions.length < MAX_CONVICTIONS && (
        <button type="button" className="vtmButton" onClick={() => change({...sheet, convictions: [...convictions, {conviction: '', touchstone: ''}]})}>
          {vtmT('addConviction')}
        </button>
      )}
    </div>
  );
};
